import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();
type RegionData = {
  translation: string;
  hostname: string;
};
type RegionType = {
  US: RegionData;
  EU: RegionData;
};

export const Regions: RegionType = {
  US: { translation: 'redirect_usDatacenter__resx', hostname: publicRuntimeConfig.SELF_US_HOST },
  EU: { translation: 'redirect_euDatacenter__resx', hostname: publicRuntimeConfig.SELF_EU_HOST }
};
